import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import '@ingka/focus/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/text/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/helper-text/dist/style.css';
import '@ingka/validation-border/dist/style.css';
import '@/styles/global.css';

// biome-ignore lint/style/noNonNullAssertion: index.html always provides #root; this is the standard Vite/React bootstrap.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
